import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { Genders } from "~enums/genders";
import type { PersonStatuses } from "~enums/personStatuses";
import type { PersonResponse } from "~types/person";
import { useApi } from "./useApi";

type CreatePerson = {
  nameFullLocal: string;
  nameFullLatin?: string | null;
  nameAbbreviated?: string | null;
  dob?: string | null;
  status: PersonStatuses;
  nationality: string;
  gender: Genders;
  additionalDetails?: null | {
    height?: number | null;
    weight?: number | null;
    representation?: string | null;
  };
  social?: null | {
    website?: string | null;
    facebook?: string | null;
    twitter?: string | null;
    wikipedia?: string | null;
    instagram?: string | null;
  };
};

export const useCreatePerson = (options: UseMutationOptions<PersonResponse, unknown, CreatePerson, unknown> = {}) => {
  const { sport, organizationId } = useParams();
  const request = useApi();

  if (!organizationId || !sport) {
    throw new Error(
      `OrganizationId or sport not found in route params. organizationId: ${organizationId}, sport: ${sport}`,
    );
  }

  return useMutation({
    mutationFn: (body: CreatePerson) =>
      request<PersonResponse>(`${sport}/o/${organizationId}/persons`, { method: "POST", body }),
    ...options,
  });
};
